webpackJsonp([4],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "IaOc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19716af0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("IaOc");
function injectStyle (ssrContext) {
  __webpack_require__("Tx/C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19716af0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MXGk":
/***/ (function(module, exports) {

if (document.documentElement.getAttribute("size")) {
	var win = window,
	    count = document.documentElement.getAttribute("size") / 100,
	    maxWidth = document.documentElement.getAttribute("size");
} else {
	var win = window,
	    count = 7.5,
	    maxWidth = 750;
}
(function (win, count, maxWidth) {
	return new function () {
		var SetSize = win.SetSize = this,
		    docHtml = document.documentElement,
		    screenRatio,
		    width,
		    scale;
		count = count || 7.5;
		maxWidth = maxWidth || 750;

		this.fontSize = 0;

		var setup = function setup() {
			var isApp = (win.navigator.appVersion.match(/android/gi), win.navigator.appVersion.match(/iphone/gi));
			screenRatio = win.devicePixelRatio;
			screenRatio = typeof win.screenRatio === 'undefined' ? isApp ? screenRatio >= 3 ? 3 : screenRatio >= 2 ? 2 : 1 : 1 : win.screenRatio;
			scale = 1 / screenRatio;
			createMeta();
		};
		var createMeta = function createMeta() {
			//document.write('<meta name="viewport" content="initial-scale=' + scale + ', maximum-scale=' + scale +', minimum-scale=' + scale + ', width=device-width, user-scalable=no" />');
			document.write('<style>body,input,textarea{font-size:' + 10 * screenRatio + 'px;}</style>');
			maxWidth = screenRatio * maxWidth;
			readSize();
			bindEvents();
		};
		var readSize = function readSize() {
			width = win.innerWidth;
			var tmpWidth = document.documentElement.clientWidth;
			if (tmpWidth != undefined && tmpWidth != null && tmpWidth != 0) {
				width = Math.min(width, tmpWidth);
			}
			if (!width && !!document.body) {
				width = document.body.clientWidth;
			} else if (!width) {
				return false;
			}
			width = Math.min(width, maxWidth);
			SetSize.fontSize = width / count;
			docHtml.style.fontSize = SetSize.fontSize + 'px';
		};
		var bindEvents = function bindEvents() {
			win.addEventListener('resize', function () {
				readSize();
			}, false);
		};

		this.getFontSize = function () {
			return SetSize.fontSize;
		};

		this.getScreenRatio = function () {
			return screenRatio;
		};

		this.getEmSize = function (px) {
			return Math.floor(px / SetSize.fontSize * 100) / 100;
		};

		setup();
	}();
})(win, count, maxWidth);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("ORbq");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.emulateJSON = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  request.credentials = true;
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Tx/C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



var index = function index(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2NXm")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var kline = function kline(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KroC")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var result = function result(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("g0mm")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/kline',
    name: 'kline',
    component: kline
  }, {
    path: '/result',
    name: 'result',
    component: result
  }, {
    path: '*',
    name: 'index',
    component: index
  }]
}));

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_SetSize_js__ = __webpack_require__("MXGk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_SetSize_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_js_SetSize_js__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.806fa58a2ea14510a5ff.js